export const reactSelectStyles = {
  control: (provided) => ({
    ...provided,
    fontSize: "12px",
    padding: "0px",
    minHeight: "30px",
  }),
  input: (provided) => ({
    ...provided,
    fontSize: "12px",
    padding: "0px",
  }),
  menu: (provided) => ({
    ...provided,
    fontSize: "12px",
    maxHeight: "205px",
    overflowY: "auto",
    zIndex: 1000,
    position: "absolute",
  }),
  menuList: (provided) => ({
    ...provided,
    fontSize: "12px",
    maxHeight: "205px",
    overflowY: "auto",
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: "12px",
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "30px",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "30px",
  }),
};
